import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "btn btn-outline-secondary btn-sm floatend",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAddClicked($event))),
      ref: "addAsset"
    }, [
      _createTextVNode(" Add " + _toDisplayString(_ctx.name) + " ", 1),
      _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
    ], 512)
  ]))
}